import "./memberlist.css";
import * as React from "react";
import Tooltip from '@mui/material/Tooltip';
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import { ButtonGroup } from "@mui/material";
import DateFilter from "./DateFilter.jsx";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Header from '../Includes/Header';
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState, useEffect, useRef } from "react";
import CancelIcon from '@mui/icons-material/Cancel';
import { Card, Button, Grid, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText, Paper } from "@mui/material";
import AppToast from '../../components/Toast/AppToast';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogContentText } from '@mui/material';
import Menu from '@mui/material/Menu';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import CircularProgress from "@mui/material/CircularProgress";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import json2mq from "json2mq";
import { Link } from 'react-router-dom';
import {
  retrieveGymMember,
  AutocompletePaymentsHistory,
  StatusMember,
  deletePaymentHistoryRecord,
  retrievePaymentHistory
} from "../Apihelper/MemberApiHelpr";
import { useNavigate } from "react-router-dom";
import { useTheme } from '@mui/material/styles';
import ListPagination, { pickTotal } from "../../components/ListPagination/ListPagination";

/** Balance/payment APIs may return rows as `payments` or legacy `data` */
function paymentHistoryListFromResponse(res) {
  const raw = res?.payments ?? res?.data;
  return Array.isArray(raw) ? raw : [];
}

/** Higher invoice number first (newest / most recent invoice on top). */
function compareInvoiceNumberDesc(a, b) {
  const na = Number(a?.invoice_number);
  const nb = Number(b?.invoice_number);
  const aOk = Number.isFinite(na);
  const bOk = Number.isFinite(nb);
  if (aOk && bOk) return nb - na;
  if (aOk) return -1;
  if (bOk) return 1;
  return String(b?.invoice_number ?? "").localeCompare(String(a?.invoice_number ?? ""), undefined, { numeric: true });
}

// Styled components
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 'bold',
    padding: '12px 16px',
    fontSize: '0.875rem',
    letterSpacing: '0.025em',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: '0.875rem',
    padding: '10px 16px',
    color: '#374151',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#f8fafc',
  },
  '&:hover': {
    backgroundColor: '#f1f5f9',
    transition: 'background-color 0.2s ease',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const MobileCard = styled(Card)(({ theme }) => ({
  margin: theme.spacing(1),
  padding: theme.spacing(1.5),
  backgroundColor: '#ffffff',
  borderRadius: '0.75rem',
  border: '1px solid #e5e7eb',
  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
}));

const drawerWidth = 292;

// The API returns these dates as "DD-MM-YYYY" — feeding that straight into
// `new Date(...)` mis-parses or fails (e.g. "18-08-2026" has day=18, which
// isn't a valid month either way), so detect and normalize it first.
const formatDateDMY = (value) => {
  if (!value) return "—";
  const ddmmyyyy = /^(\d{2})-(\d{2})-(\d{4})$/.exec(value);
  const d = ddmmyyyy ? new Date(`${ddmmyyyy[3]}-${ddmmyyyy[2]}-${ddmmyyyy[1]}`) : new Date(value);
  if (isNaN(d.getTime())) return "—";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  return `${day}-${month}-${d.getFullYear()}`;
};

function PaymentHistory(props) {
  const { colors: appColors } = useAppTheme();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);
  const { conversationId, onGoBackToMemberDetails } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const dateRef = useRef();
  const [age, setAge] = React.useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const filterRef = useRef({ search: '', datelist: '', from: '', to: '' });
  const [status, setstatus] = useState('');
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null); // { id, payment_type, invoice_number }
  const [deletingRecord, setDeletingRecord] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      setIsAdmin(userDataObj?.role === 'admin');
    } catch {
      setIsAdmin(false);
    }
  }, []);
  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );
  const handleToggle = (id,status) => {
    setOpenConfirmation(true);
   const newStatus = status === 1 ? 0 : 1;
  setstatus(newStatus);
  setDeleteConfirmationId(id);
  setIsActive(newStatus === 0);

  };
 
  const drawer = (
    <div className="d-flex flex-column h-100">
      <Header />
    </div>
  );
 
  const [options, setOptions] = useState([]);
  const [fetchdatarow, setetchdatarow] = useState([]); 
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openToast, setOpenToast] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // Default to 'success'
  const [index, setIndex] = useState(0);
  const [datelist, setDatelist] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [todate, settodate] = useState("");
  const [textsearch, settextsearch] = useState("");
  const open = Boolean(anchorEl);
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // One page of this member's payments for the current search / date filter. The filters live
  // in a ref so changing page or rows-per-page keeps them.
  const loadPage = async (pageZero = 0, size = rowsPerPage) => {
    setLoading(true);
    try {
      const userDataObj = JSON.parse(localStorage.getItem("userdata"));
      const f = filterRef.current;
      const res = await retrievePaymentHistory(
        userDataObj.token,
        userDataObj.id,
        conversationId,
        f.search,
        size,
        pageZero * size,
        f.datelist,
        f.from,
        f.to
      );

      if (res.code == "200" || res.code === 200) {
        const rows = paymentHistoryListFromResponse(res);
        if (rows.length === 0 && pageZero > 0) {
          // The last row of the last page was just removed: step back one page.
          await loadPage(pageZero - 1, size);
          return;
        }
        setetchdatarow(rows);
        setPage(pageZero);
        const total = pickTotal(res);
        setTotalCount(total != null ? total : pageZero * size + rows.length);
      } else {
        setetchdatarow([]);
        setTotalCount(0);
        setPage(0);
      }
    } catch (error) {
      console.error(error);
      handleSnackbarOpen("Request failed", 'error');
    } finally {
      setLoading(false);
    }
  };

  // Search (plain text, no date filter) — starts at page 0. No argument = refresh the current page.
  const fetchData = (value) => {
    if (value === undefined) return loadPage(page);
    settextsearch(value || '');
    filterRef.current = { search: value || '', datelist: '', from: '', to: '' };
    return loadPage(0);
  };

  useEffect(() => {
    filterRef.current = { search: '', datelist: '', from: '', to: '' };
    loadPage(0);
  }, [conversationId]);

const handleClearButtonClick = async () => {
  settodate("");
  setFromDate("");
  setDatelist("");
  settextsearch('');
  dateRef.current.handleResetClick();
  filterRef.current = { search: '', datelist: '', from: '', to: '' };
  await loadPage(0);
};

const handleSearchChange = (event, value) => {
  const searchText = value || ''; // If value is undefined or empty, set searchText to empty string
  // setSearchText(searchText);
  // Call fetchData function here with the updated searchText
  fetchData(searchText);
};


const handleInputChange = async (value) => {
  if (value.length >= 3) {
  try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id; // Assuming you have a userId in userdata
      const searchText = value; // Example search text
    
      const res = await AutocompletePaymentsHistory(userToken, userId, searchText);

      if (res.code == "200") {
          const names = res.data.map(item => item.search_text);
          setOptions(names);
      } else {
          handleSnackbarOpen(res.message, 'error');
          //  console.error(error); // Handle error
      }
  } catch (error) {
      console.error(error);
      // Handle errors
  }
}
};
const DELETABLE_PAYMENT_TYPES = ['Main Package', 'Trainer Package', 'Yearly Membership'];

const handleDeleteRecordClick = (row) => {
  setDeleteTarget(row);
  setOpenDeleteConfirmation(true);
};

const handleCancelDeleteRecord = () => {
  setOpenDeleteConfirmation(false);
  setDeleteTarget(null);
};

const handleConfirmDeleteRecord = async () => {
  if (!deleteTarget) return;
  setDeletingRecord(true);
  try {
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;

    const res = await deletePaymentHistoryRecord(userToken, deleteTarget.id, deleteTarget.payment_type);

    if (res.code == "200") {
      handleSnackbarOpen(res.message, 'success');
      setetchdatarow((prev) =>
        Array.isArray(prev)
          ? prev.filter((r) => !(r.id === deleteTarget.id && r.payment_type === deleteTarget.payment_type))
          : prev
      );
      setOpenDeleteConfirmation(false);
      setDeleteTarget(null);
      loadPage(page);
    } else {
      handleSnackbarOpen(res.message, 'error');
    }
  } catch (error) {
    console.error(error);
    handleSnackbarOpen('Failed to delete payment record', 'error');
  } finally {
    setDeletingRecord(false);
  }
};




React.useEffect(() => {
  const storedData = localStorage.getItem("userdata");
  if (!storedData) {
    // User is not logged in, no need to redirect
    navigate('/');
  }
  
}, []);
const handleNavigate = (invoiceNumber) => {
  navigate('/invoice', {  state: {
    invoice_number: invoiceNumber,
    conversation_id: conversationId,
  }, });
};
const handleApplydatecustom = async ({ fromDateval, toDateval }) => {
  settodate(toDateval);
  setFromDate(fromDateval);
  filterRef.current = { search: textsearch, datelist: datelist, from: fromDateval, to: toDateval };
  await loadPage(0);
};

const handleApplydate = async (selectedValue) => {
  setDatelist(selectedValue);
  filterRef.current = { search: textsearch, datelist: selectedValue, from: '', to: '' };
  await loadPage(0);
};

  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      p: 2,
      backgroundColor: '#f8fafc',
      borderRadius: '16px',
      border: '1px solid #e2e8f0',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
     
      overflow: 'hidden',
      '& > *': {
        borderRadius: '12px',
      }
    }}>
      <Box
        sx={{
          backgroundColor: 'white',
          p: { xs: 2, sm: 2.5 },
          borderRadius: '12px',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1.5,
          alignItems: 'center',
        }}
      >
        <Button
          variant="text"
          startIcon={<ArrowBackIcon sx={{ fontSize: 18 }} />}
          onClick={() => (onGoBackToMemberDetails ? onGoBackToMemberDetails() : navigate(-1))}
          sx={{
            color: '#475569',
            fontWeight: 600,
            textTransform: 'none',
            px: 1.25,
            '&:hover': { backgroundColor: 'rgba(148, 163, 184, 0.12)' },
          }}
        >
          Go Back
        </Button>

        <TextField
          size="small"
          placeholder="Search invoice, mode of payment..."
          variant="outlined"
          onChange={(e) => handleInputChange(e.target.value)}
          sx={{
            width: { xs: '100%', sm: 280 },
            backgroundColor: '#f8fafc',
            '& .MuiOutlinedInput-root': {
              borderRadius: '999px',
              '& fieldset': { borderColor: '#e2e8f0' },
              '&:hover fieldset': { borderColor: appColors.leaf },
              '&.Mui-focused fieldset': { borderColor: appColors.leaf },
              '&.Mui-focused': { backgroundColor: '#ffffff' },
            },
          }}
          InputProps={{
            type: 'search',
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: 20, color: '#94a3b8' }} />
              </InputAdornment>
            ),
          }}
        />

        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center', ml: { xs: 0, md: 'auto' } }}>
          <DateFilter
            ref={dateRef}
            onApplycustomdate={handleApplydatecustom}
            onApply={handleApplydate}
          />

          <Button
            variant="text"
            startIcon={<CancelIcon sx={{ fontSize: 18 }} />}
            onClick={handleClearButtonClick}
            sx={{
              color: '#64748b',
              fontWeight: 600,
              textTransform: 'none',
              px: 1.25,
              '&:hover': { backgroundColor: 'rgba(148, 163, 184, 0.12)' },
            }}
          >
            Clear All
          </Button>
        </Box>
      </Box>

      {loading ? (
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          p: 3,
          backgroundColor: 'white',
          borderRadius: '12px',
        }}>
          <CircularProgress sx={{ color: appColors.leaf }} />
            </Box>
      ) : (
        <>
          {isMobile ? (
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: 1.5,
              backgroundColor: 'white',
              p: { xs: 2, sm: 3 },
              borderRadius: '12px',
              boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
            }}>
              {[...(Array.isArray(fetchdatarow) ? fetchdatarow : [])]
                .sort(compareInvoiceNumberDesc)
                .map((row, index) => (
                <MobileCard key={index}>
                  <Grid container spacing={1.5}>
                    <Grid item xs={12}>
                      <Typography 
                        variant="subtitle2" 
                        sx={{ 
                          color: appColors.leaf,
                          fontWeight: 600,
                          mb: 1
                        }}
                      >
                        Invoice No:
                        <Tooltip 
                          title="Click to view invoice document" 
                          arrow 
                          placement="top"
                        >
                          <Button
                            onClick={() => handleNavigate(row.invoice_number)}
                            sx={{ 
                              color: appColors.leaf,
                              textTransform: 'none',
                              fontWeight: 600,
                              textDecoration: 'underline',
                              textUnderlineOffset: '2px',
                              textDecorationColor: '#93c5fd',
                              textDecorationThickness: '1px',
                              padding: '4px 8px',
                              minWidth: 'auto',
                              '&:hover': {
                                backgroundColor: 'rgba(31, 122, 84, 0.04)',
                                textDecorationColor: appColors.leaf,
                                textDecorationThickness: '1.5px',
                              }
                            }}
                          >
                            {row.invoice_number}
                          </Button>
                        </Tooltip>
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" sx={{ color: '#374151', fontWeight: 500 }}>
                        <strong>Payment Date:</strong>
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6b7280' }}>
                        {formatDateDMY(row.date)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" sx={{ color: '#374151', fontWeight: 500 }}>
                        <strong>Start Date:</strong>
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6b7280' }}>
                        {formatDateDMY(row.start_date)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" sx={{ color: '#374151', fontWeight: 500 }}>
                        <strong>Due Date:</strong>
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6b7280' }}>
                        {formatDateDMY(row.end_date)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" sx={{ color: '#374151', fontWeight: 500 }}>
                        <strong>Payment Mode:</strong>
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6b7280' }}>
                        {row.mode_of_payment}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" sx={{ color: '#374151', fontWeight: 500 }}>
                        <strong>Amount:</strong>
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#059669' }}>
                        ₹{row.amount}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" sx={{ color: '#374151', fontWeight: 500 }}>
                        <strong>Due:</strong>
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#dc2626' }}>
                        ₹{row.due}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" sx={{ color: '#374151', fontWeight: 500 }}>
                        <strong>Type:</strong>
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6b7280' }}>
                        {row.payment_type}
                        {row.package_name && ` — ${row.package_name}`}
                      </Typography>
                    </Grid>
                    {isAdmin && DELETABLE_PAYMENT_TYPES.includes(row.payment_type) && (
                      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          size="small"
                          startIcon={<DeleteIcon fontSize="small" />}
                          onClick={() => handleDeleteRecordClick(row)}
                          sx={{ color: '#dc2626', textTransform: 'none', fontWeight: 600 }}
                        >
                          Delete
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </MobileCard>
              ))}
            </Box>
          ) : (
            <Box sx={{
              backgroundColor: 'white',
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
            }}>
              <TableContainer 
                component={Paper} 
                sx={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid #e5e7eb',
                  '& .MuiTable-root': {
                    borderCollapse: 'separate',
                    borderSpacing: 0,
                  },
                  '& .MuiTableCell-root': {
                    borderBottom: '1px solid #e5e7eb',
                  },
                  boxShadow: 'none',
                }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Payment Date</StyledTableCell>
                      <StyledTableCell>Start Date</StyledTableCell>
                      <StyledTableCell>Due Date</StyledTableCell>
                      <StyledTableCell>Invoice No</StyledTableCell>
                      <StyledTableCell>Payment Mode</StyledTableCell>
                      <StyledTableCell>Paid Amount</StyledTableCell>
                      <StyledTableCell>Due Balance</StyledTableCell>
                      <StyledTableCell>Details</StyledTableCell>
                      {isAdmin && <StyledTableCell align="right">Actions</StyledTableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                    {[...(Array.isArray(fetchdatarow) ? fetchdatarow : [])]
                      .sort(compareInvoiceNumberDesc)
                      .map((row, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell>
                          {formatDateDMY(row.date)}
                        </StyledTableCell>
                        <StyledTableCell>
                          {formatDateDMY(row.start_date)}
                        </StyledTableCell>
                        <StyledTableCell>
                          {formatDateDMY(row.end_date)}
                        </StyledTableCell>
                        <StyledTableCell>
                          <Tooltip 
                            title="Click to view invoice document" 
                            arrow 
                            placement="top"
                          >
                            <Button
    onClick={() => handleNavigate(row.invoice_number)}
                              sx={{
                                color: appColors.leaf,
                                textTransform: 'none',
                                textDecoration: 'underline',
                                textUnderlineOffset: '2px',
                                textDecorationColor: '#93c5fd',
                                textDecorationThickness: '1px',
                                padding: '4px 8px',
                                minWidth: 'auto',
                                fontWeight: 500,
                                '&:hover': {
                                  backgroundColor: 'rgba(31, 122, 84, 0.04)',
                                  textDecorationColor: appColors.leaf,
                                  textDecorationThickness: '1.5px',
                                }
    }}
  >
    {row.invoice_number}
                            </Button>
                          </Tooltip>
                        </StyledTableCell>
                        <StyledTableCell>{row.mode_of_payment}</StyledTableCell>
                        <StyledTableCell>₹{row.amount}</StyledTableCell>
                        <StyledTableCell>₹{row.due}</StyledTableCell>
                        <StyledTableCell>
                          {row.payment_type}
                          {row.package_name && (
                            <Typography component="span" sx={{ display: 'block', fontSize: 11, color: '#6b7280' }}>
                              {row.package_name}
                            </Typography>
                          )}
                        </StyledTableCell>
                        {isAdmin && (
                          <StyledTableCell align="right">
                            {DELETABLE_PAYMENT_TYPES.includes(row.payment_type) && (
                              <Tooltip title="Delete this payment record">
                                <IconButton
                                  size="small"
                                  onClick={() => handleDeleteRecordClick(row)}
                                  sx={{ color: '#dc2626', '&:hover': { backgroundColor: 'rgba(220, 38, 38, 0.08)' } }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </StyledTableCell>
                        )}
                      </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              </TableContainer>
            </Box>
          )}

          <ListPagination
            count={totalCount}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={(p) => loadPage(p)}
            onRowsPerPageChange={(size) => { setRowsPerPage(size); loadPage(0, size); }}
          />
        </>
      )}

      <Dialog open={openDeleteConfirmation} onClose={handleCancelDeleteRecord} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ color: appColors.leaf, fontWeight: 600 }}>Delete Payment Record</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this {deleteTarget?.payment_type} payment
            {deleteTarget?.invoice_number ? ` (Invoice #${deleteTarget.invoice_number})` : ''}?
            This will also delete its linked invoice. This action cannot be undone, and only this
            one record is affected — no other payment or member data is touched.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, gap: 1 }}>
          <Button onClick={handleCancelDeleteRecord} sx={{ textTransform: 'none', fontWeight: 600, color: '#64748b' }}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDeleteRecord}
            disabled={deletingRecord}
            variant="contained"
            sx={{ textTransform: 'none', fontWeight: 600, bgcolor: '#dc2626', '&:hover': { bgcolor: '#b91c1c' } }}
          >
            {deletingRecord ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
    </Box>
  );
}

export default PaymentHistory;